import { MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router";
import { Badge } from "@/components/ui/badge";
import { Image } from "@/components/shared/image-fallback";
import { Property } from "@/models/properties.model";
import { $FIXME } from "@/interfaces";

interface PropertyCardProps {
  property: Property;
}

export default function PropertyCard({ property }: PropertyCardProps) {
  return (
    <Link to={`/properties/${property.id}`}>
      <Card
        key={property.id}
        className="overflow-hidden border-0 shadow-sm hover:shadow-md transition-shadow p-0 rounded-sm gap-0"
      >
        <div className="relative">
          <Image src={property.image as $FIXME} alt={property.name} className="w-full h-48 object-cover" />
          <div className="absolute top-2 right-2">
            <Badge variant="secondary" className="rounded-sm">
              Class {property.class?.join(", ")}
            </Badge>
          </div>
        </div>
        <CardContent className="p-4">
          <h3 className="font-medium text-md mb-2">{property.name}</h3>
          <div className="flex items-center text-gray-500 text-sm mb-2">
            <MapPin className="h-4 w-4 mr-1 text-foreground" />
            <span className="truncate text-foreground">{property.address}</span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
